import { render, staticRenderFns } from "./UserData0.vue?vue&type=template&id=e4784810&scoped=true"
import script from "./UserData0.vue?vue&type=script&lang=ts"
export * from "./UserData0.vue?vue&type=script&lang=ts"
import style0 from "./UserData0.vue?vue&type=style&index=0&id=e4784810&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4784810",
  null
  
)

export default component.exports